import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "../Modal";
import { Button } from "../Button";
import { ApiError } from "../../Common/Hooks/useApi/Schemas";

export const CHAT_CREDIT_REQUIRED_ERROR_CODE = "CHAT_CREDIT_REQUIRED";

export const isChatCreditError = (error: ApiError): boolean =>
  error.errorCode === CHAT_CREDIT_REQUIRED_ERROR_CODE;

export const ChatCreditModal = ({
  message,
  onDismiss,
  onBuy,
}: {
  message: string | null;
  onDismiss: () => void;
  onBuy: () => void;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (message === null) return null;

  const handleBuyClick = () => {
    onBuy();
    navigate("/buy-credits");
  };

  const handleSubscribeClick = () => {
    // Same cleanup as buying: close the modal without painting the bot bubble
    onBuy();
    navigate("/choose-plan");
  };

  return (
    <Modal isOpen onClose={onDismiss} fullScreen={false}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          width: "100%",
          maxWidth: "500px",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: 600,
            color: "#111827",
            margin: 0,
          }}
        >
          {t("chat.chatCreditModal.title")}
        </h2>
        <p
          style={{
            color: "#6B7280",
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {message}
        </p>
        <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
          <Button
            onClick={handleBuyClick}
            style={{
              backgroundColor: "#3B82F6",
              color: "#ffffff",
              width: "100%",
            }}
          >
            {t("chat.chatCreditModal.buyButton")}
          </Button>
          <Button
            onClick={handleSubscribeClick}
            style={{
              backgroundColor: "#ffffff",
              color: "#001d30",
              border: "1px solid #001d30",
              width: "100%",
            }}
          >
            {t("chat.chatCreditModal.subscribeButton")}
          </Button>
          <p
            onClick={onDismiss}
            style={{
              textAlign: "center",
              color: "#6B7280",
              cursor: "pointer",
              margin: 0,
              padding: "0.5rem 0",
              transition: "color 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#111827";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#6B7280";
            }}
          >
            {t("chat.chatCreditModal.closeButton")}
          </p>
        </div>
      </div>
    </Modal>
  );
};
